<template>
  <div class="access-denied">
    <img src="@/assets/vectors/access_denied.png" alt="no access">
    <h1>Access Denied</h1>
    <p>Sorry! You haven't access to view this page.</p>
    <router-link :to="redirectPath">{{ buttonText }}</router-link>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isLoggedIn = !!localStorage.getItem("token_set");

const redirectPath = ref(
  isLoggedIn ? "/" : "/login"
);

const buttonText = ref(
  isLoggedIn ? "Back to Home" : "Back to Login"
);
</script>

<style scoped>
.access-denied {
  text-align: center;
  margin-top: 100px;
}

.access-denied img {
  width: 30%;
}

.access-denied h1 {
  color: #ec5648;
  font-size: 2rem;
  font-weight: bold;
}

.access-denied p {
  margin: 20px 0;
}

.access-denied a {
  background-color: #ec5648;
  padding: 10px 20px;
  border-radius: 8px;
  color: #ffffff;
}
</style>
